(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('sc3SelectOnFocus', selectOnFocusDirective);

    selectOnFocusDirective.$inject = ['$timeout'];
    function selectOnFocusDirective($timeout) {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, element, attr, ctrl) {
            if (element[0].select) 
                element.on('focus', $timeout.bind(null, element[0].select.bind(element[0]), 0, false));
        }
    }
})();
